import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { QRCodeModule } from 'angularx-qrcode';
import { MenuComponent } from './menu/menu.component';
import { ItemComponent } from './menu/item/item.component';

@NgModule({
    declarations: [
        MenuComponent,
        ItemComponent,
    ],
    imports: [
        CommonModule,
    ],
    exports: [
        MenuComponent,
        ItemComponent,
    ]
})
export class ComponentsModule { }
